import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsOrderProgress.less';

export default class GoodsOrderProgress extends OfficialPage {
  state = {
    orderFlowData: []
  }
  orderId = ''

  constructor(props) {
    super(props);
    document.title = '订单进度';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.orderId = options.orderId
    this.getOrderFlow()
  }

  componentDidMount() { }

  getOrderFlow = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appShop/getOrderFlow',
      data: {
        order_id: _this.orderId
      },
      success: function (res) {
        let orderFlowData = res.data.reverse()
        _this.setData({
          orderFlowData: orderFlowData
        })
      }
    })
  }

  render() {
    const { showGetUserInfo, orderFlowData } = this.state
    return (
      <div className="official-page goods-order-progress">
        <TopNav title="订单进度" />
        <div className="progress-contain">
          <div className="progress-header">
            <div>买家操作</div>
            <div>卖家操作</div>
          </div>
          <div className="progress-content">
            {orderFlowData.map((item, index) => {
              return (
                <div className="content-box" key={item.id}>
                  <div className="progress-left">
                    {!!item.is_custom && (
                      <React.Fragment>
                        <span>{item.content.msg}</span>
                        <span className="progress-time">{item.op_time}</span>
                      </React.Fragment>
                    )}
                  </div>
                  <div className="progress-center"></div>
                  <div className="progress-right">
                    {!item.is_custom && (
                      <React.Fragment>
                        <span>{item.content.msg}</span>
                        <span className="progress-time">{item.op_time}</span>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-order-progress/GoodsOrderProgress.jsx